export const CSS_CLASSES = {
  INPUT_ROOT: "input-root",

  INPUT_ELEMENT: "input-element",

  INPUT_SMALL: "small",
  INPUT_MEDIUM: "medium",
  INPUT_LARGE: "large",

  INPUT_PRIMARY: "primary",

  INPUT_ERROR: "error",
  INPUT_SUCCESS: "success",
  INPUT_DISABLED: "disabled",

  INPUT_ENHANCER_WRAPPER: "input-enhancer-wrapper",
  INPUT_START_ENHANCER_WRAPPER: "input-start-enhancer-wrapper",
  INPUT_END_ENHANCER_WRAPPER: "input-end-enhancer-wrapper",

  INPUT_ENHANCER: "input-enhancer",
  INPUT_SMALL_START_ENHANCER: "input-small-start-enhancer",
  INPUT_SMALL_END_ENHANCER: "input-small-end-enhancer",
  INPUT_MEDIUM_START_ENHANCER: "input-medium-start-enhancer",
  INPUT_MEDIUM_END_ENHANCER: "input-medium-end-enhancer",
  INPUT_LARGE_START_ENHANCER: "input-large-start-enhancer",
  INPUT_LARGE_END_ENHANCER: "input-large-end-enhancer",

  INPUT_CLEAR_BUTTON: "input-clear-button",
  INPUT_SMALL_CLEAR_BUTTON: "input-small-clear-button",
  INPUT_CLEAR_BUTTON_WITH_END_ENHANCER: "input-clear-button-with-end-enhancer",

  INPUT_TAGS: "input-tags",
};
